<template>
  <div>
    <div v-if="(set_ctaType == 1 || set_ctaType == 3)">
      <span v-if="set_productMainView == 'cartactions'" >
        <!-- <button v-if="canAdd" class="cart-btn cart-btn-sm" @click="addToCart">Add to Cart</button> -->
        <div v-if="canAdd">
          <button v-if="set_ctaType == 1" style="width:50vw;" class="cart-btn cart-btn-sm" @click="addToCart">Add to Cart</button>
          <!-- <button v-if="set_ctaType == 3" class="cart-btn cart-btn-sm" @click="addToCart">Add to Co-Pay</button> -->
        </div>
        <div v-else>
          <div class="hidden-sm hidden-xs">
            <div class="cart-cta-box">
              <!-- <li> <a class="cart-btn btn-white remove-btn" @click="removeFromCart(set_productItem)"><i class="fa fa-trash"></i> Remove from Cart</a></li> -->
              <button  class="cart-btn cart-btn-sm" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
              <!-- <li style="margin-top: 2em;"> <a  class="cart-btn btn-white btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</a></li> -->
            </div>
          </div>
          <div class="hidden-md hidden-lg">
            <!-- <button style="background:#e05024" class="cart-btn remove-btn" @click="removeFromCart(set_productItem)"><i class="fa fa-trash"></i> Remove from Cart</button> -->
            <button style="line-height:2em" class="cart-btn cart-btn-sm" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
            <!-- <button style="line-height:2em" class="cart-btn btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</button>  -->
          </div>
        </div>
      </span>
      <div v-else style="clear:right;">
        <div v-if="canAdd">
          <button v-if="set_ctaType == 1" style="width:50vw;" class="cart-btn cart-btn-sm" @click="addToCart">Add to Cart</button>
          <!-- <button v-if="set_ctaType == 3" class="cart-btn cart-btn-sm" @click="addToCart">Add to Co-Pay</button> -->
        </div>
        <div v-else>
          <button class="cart-btn" @click="redir('cart')" style="width:50vw; font-size:14px;">View Cart</button>
        </div>
        <!-- <button v-if="canAdd" class="cart-btn" @click="addToCart" style="width:50vw;">Add to Cart</button>
        <button v-else class="cart-btn" @click="redir('cart')" style="width:50vw; font-size:14px;">View Cart</button> -->
        <!-- <div v-else> -->
        <div style="display:none">
          <div class="hidden-sm hidden-xs mobi-off">
            <ul class="cart-cta-box">
              <li class="cart-btn btn-white remove-btn"><a  @click="removeFromCart(set_productItem)"><i class="fa fa-trash"></i> Remove <br> from Cart</a></li>
              <li class="cart-btn view-btn"><a href="/cart"><i class="fa fa-shopping-cart"></i> View <br> Cart</a></li>
              <li class="cart-btn btn-white btn-primary"><a  @click="redir(set_productMain.product_business_ownername)"><i class="fa fa-shopping-cart"></i> Continue <br>  Shopping</a></li>
            </ul>
          </div>
          <div class="hidden-md hidden-lg mobi-on">
            <button style="background:#e05024" class="cart-btn remove-btn" @click="removeFromCart(set_productItem)"><i class="fa fa-trash"></i> Remove from Cart</button>
            <button style="line-height:2em" class="cart-btn view-btn" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
            <button style="line-height:2em" class="cart-btn btn-primary" @click="redir(set_productMain.product_business_ownername)"><i class="fa fa-shopping-cart"></i> Continue Shopping</button> 
          </div>
        </div>
      </div>
    </div>
    <div v-if="set_ctaType == 2">
      <div v-if="canAdd">
        <button v-if="set_productMainView == 'cartactions'" class="cta-btn cta-btn-sm" @click="addToCart" style="width:100vw;"> {{set_productMain.product_cta_name || ' Buy Now'}}</button>
        <button  v-else class="cta-btn" @click="addToCart" style="width:100vw;"> {{set_productMain.product_cta_name || ' Buy Now'}}</button>
      </div>
      <div v-else>
        <button class="cta-btn" @click="redir(set_productMain.product_business_ownername)" style="width:50vw; text-align:left; padding-left:5px; font-size:14px;"> Continue Shopping</button>
      </div>
    </div>
  </div>
</template>
<style>
  .cart-cta-box {
    padding-left: 0;
  }
  .cart-cta-box li{
    /* display: inline; */
    width:30%;
    margin:0 3px;
    cursor: pointer;
    padding: 3px 1em;
  }

  .cart-cta-box  a{
    cursor: pointer;
    /* line-height: 1em; */
    text-decoration: none;
    font-size: 14px;
  }

  .btn-white:hover{
    color: #ffffff;
  }
  .btn-black:hover{
    color: #000000;
  }
  .cart-btn-sm{
    /* line-height: 1.2; */
    font-size: 12px;
  }
 .cart-btn{
   width: 100%;
    border: none;
    /* border-radius: 3px; */
    box-shadow: none;
    white-space: nowrap;
    color: #ffffff;
    padding: 10px 30px;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    background: #FF0040;
    /* background: #ee992b; */
    /* background: #ffc13b; */
    letter-spacing: 1px;
    position: relative;
    text-align: center;
    z-index: 1;
 }

 .remove-btn{
   background: #ee2b2b;
 }

  .view-btn{
    background: #dde3e9;
    color:#000000;
  }

 @media only screen 
  and (min-device-width: 300px) 
  and (max-device-width: 640px){
    .cart-btn{
      padding: 10px 10px;
      width: 100%;
    }
  }

   .cta-btn-sm{
  /* padding:3px; */
  /* line-height: 1.2; */
  font-size: 12px;
}
  .cta-btn{
    width: 100%;
    border: none;
    /* border-radius: 3px; */
    box-shadow: none;
    white-space: nowrap;
    color: #ffffff;
    padding: 10px 40px;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    /* background: #fd9729; */
    background: #FF0040;
    /* background: #339900; */
    letter-spacing: 1px;
    position: relative;
    text-align: center;
    z-index: 1;
  }
  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 640px){
    .cta-btn{
      padding: 10px 10px;
      font-size: 16px;
      
    }
  }
</style>
<script>
  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../../store/mutation-types'
  export default {
    props: ['ctaType','productMain','productItemGroup','productItem','productMainView'],
    data () {
      return {
        set_ctaType:0,
        set_productMain:{},
        set_productItemGroup:{},
        set_productItem:{},
        set_productMainView:{},
        cart: this.$store.state.cart
      }
    },
    computed: {
      canAdd () {
        // return this.cart.indexOf(this.set_productItem) < 0
        const index = this.cart.findIndex(p => p.product_item_id === this.set_productItem.product_item_id) //best removal
        if(index < 0){
          return true;
        }
      }
    },
    methods: {
      addToCart () {
        //settings

        //--if active order eg buy now
        if(this.set_ctaType == 2){
          this.set_productItem.active_order = true;
          this.set_productItem.product_buy_now_ref = 'qx-r'; //some sett
        }
        //---//

        //--prepare set_productItem for adding to cart
        this.set_productItem._id = this.set_productItem.product_item_id;
        //config qty if not set
        if(this.set_productItem.product_item_order_quantity == undefined){
          this.set_productItem.product_item_order_quantity = 1;
        }
        this.set_productItem.product_main_id = this.set_productMain.product_id;
        this.set_productItem.product_business_name = this.set_productMain.product_business_name;
        this.set_productItem.product_business = this.set_productMain.product_business_ownername;
        this.set_productItem.product_name = this.set_productMain.product_name;
        this.set_productItem.product_url = this.set_productMain.product_business_ownername+"/"+this.set_productMain.product_url_name;
        this.set_productItem.product_item_quantity = this.set_productItem.product_item_quantity;
        this.set_productItem.product_item_need_shipping = this.set_productMain.product_need_shipping;
        //some settings 
        //for product items images
        if((this.set_productItemGroup.product_item_group_is_color_image == 'IMG') && (this.set_productItemGroup.product_item_group_image != 'error')){
          this.set_productItem.product_item_image = this.set_productItemGroup.product_item_group_image;
        }else{ //is color or error
          this.set_productItem.product_item_image = '';
        }
        //for product_shipping_calculation_method
        this.set_productItem.product_shipping_calculation_method = this.set_productMain.product_set_shipping_fee_status;
        //../some settings 

        //some additional settings for cart circle to avoid mutation errors
        this.set_productItem.can_remove = true; //for removal when not selected for checkout at cart
        
        //cart sorting settings
        this.set_productItem.product_business_sort = this.set_productMain.product_business_ownername;

        //custom price settings
        // this.set_productItem.product_custom_set_price = 
        // this.set_productItem.product_custom_set_price_type =

        //agent settings
        this.set_productItem.product_referral_bash = "";
        this.set_productItem.product_has_referral_bash = 0;
        let product_ref = "REF-"+this.set_productMain.product_url_name;
        let ref_check = localStorage.getItem(product_ref);
        if(ref_check && ((ref_check != null) || (ref_check != ''))){
          this.set_productItem.product_has_referral_bash = 1;
          this.set_productItem.product_referral_bash = ref_check;
        }
        //check product referral
        // if(this.set_productMain.product_agent_ship.product_business_is_agent == 1){
        if(this.set_productMain.product_agent_ship && Object.keys(this.set_productMain.product_agent_ship).length > 0){
          if((this.set_productMain.product_agent_ship.product_business_is_agent) && (this.set_productMain.product_agent_ship.product_business_is_agent == 1)){
            this.set_productItem.product_is_from_agent = this.set_productMain.product_agent_ship.product_business_is_agent;
            this.set_productItem.product_business_agent_name = this.set_productMain.product_agent_ship.product_business_agent_name;
            this.set_productItem.product_business_agent_username = this.set_productMain.product_agent_ship.product_business_agent_username;
            this.set_productItem.product_business_sort = this.set_productMain.product_agent_ship.product_business_agent_username;
          }
        }
        //.../agent settings
        
        //service subscription update settings
        if(localStorage.getItem("product_sub")){
          let sub_check = localStorage.getItem("product_sub");
          if(sub_check && ((sub_check != null) || (sub_check != undefined) || (sub_check != ''))){
            this.set_productItem.product_is_updated_subscription = 1;
            this.set_productItem.product_current_subscription = sub_check;
          }
        }

        //product-order donate-to-buy, part-payments
        if(this.set_ctaType == 3){// part-payments
          this.set_productItem.product_order_part_payments_request = 1; //active
        }
        //../
        
        //prepare addon
        //---add addons to product if have
        if(this.set_productMain.selected_product_addons && (this.set_productMain.selected_product_addons.length > 0)){
          this.set_productItem.product_item_order_has_addon_orders = 1;
          this.set_productItem.product_order_addons  = this.set_productMain.selected_product_addons;
        }
        //---set product_added_on to if has
        if(this.set_productMain.product_order_addon_to && (this.set_productMain.product_order_addon_to > 0) ){
          this.set_productItem.product_item_order_is_add_on_to = this.set_productMain.product_order_addon_to;
        }
        //../addons

        //set buy-now-ref
        if(this.set_ctaType == 2){
          // this.set_productItem.product_buy_now_ref = 'qx-r'+this.set_productItem.product_item_id+this.set_productItem.product_url;
          this.set_productItem.product_buy_now_ref = 'qx-r'+this.set_productItem.product_item_id;
        }

        //
        this.$store.commit(ADD_TO_CART, this.set_productItem);
        
        //check if has selected addons
        if(this.set_productMain.selected_product_addons && (this.set_productMain.selected_product_addons.length > 0)){
          this.addProductAddonsToCart(this.set_productMain.selected_product_addons);
        }
        //./

        if(this.set_ctaType == 2){// buy-now
          //--set at localsorage
          localStorage.removeItem('bnrf');
          localStorage.setItem('bnrf',this.set_productItem.product_buy_now_ref);
          //....this.redir('order');//push to order
          //set order view
          this.setXView('order');
        }
      },

      // removeFromCart (id) {
      //   this.$store.commit(REMOVE_FROM_CART, id)
      // },
      removeFromCart (payload) {
        this.$store.commit(REMOVE_FROM_CART, payload)
      },

      redir(rlink){
            location.replace("/"+rlink)
      },

      //add product addons to cart
      addProductAddonsToCart(selected_product_addons){
        //prepare their data to be added to cart
        // $ad_count = 0; 
        for(let product_addon of selected_product_addons){
          //set attributes needed
          this.set_ctaType = 1; //add to cart //default
          this.set_productMain = product_addon.productMain;
          this.set_productItemGroup = product_addon.productItemGroup; //as set during addon for add to cart
          this.set_productItem = product_addon.productItem;
          this.set_productMainView = '';
            
          //after setting call addtocart
          this.addToCart();
        }
      }
    },
    created: function(){
      //settings
      //--set get props //to avoid using it directly thereby preserving it
      this.set_ctaType = this.ctaType;
      this.set_productMain = this.productMain;
      this.set_productItemGroup = this.productItemGroup;
      this.set_productItem = this.productItem
      this.set_productMainView = this.productMainView;
      //---setting props
      if(this.set_ctaType == 2){ //buy-now
        if(this.set_productMain.product_cta_name && (this.set_productMain.product_cta_name == 'error')){
          this.set_productMain.product_cta_name = "Buy Now";
        }
      }
      //
      this.set_productMain.product_cta_name = "Place Order";
    }
  }
</script>



// WEBPACK FOOTER //
// ProductCartActions.vue?5e5ff606